import {
  Menu,
  SubMenu,
  MenuItem,
  DiskIcon,
  UserIcon,
  ForwardIcon,
  KeyIcon,
  BarChartIcon,
  DownloadIcon,
  ToolIcon,
} from "melco-ui";
import { useMainMenu } from "melco-shared-logic";
import { useRolesContext } from "../../hooks/roles/useRolesContext";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Summit } from "../../screens/summit/Summit";
import StyledModal from "../modal/StyledModal";

export const MainMenuControlCenter: React.FC = () => {
  const { selectedKeys, onClick } = useMainMenu();
  const { roles } = useRolesContext();
  const { t } = useTranslation();
  const [openSUMMIT, setOpenSUMMIT] = useState(false);

  return (
    <><Menu
      mode="inline"
      selectedKeys={selectedKeys}
      defaultOpenKeys={selectedKeys}
      onClick={onClick}
    >
      {roles.DASHBOARD && (
        <MenuItem key="/dashboard" icon={<BarChartIcon />}>
          {t("main_menu.dashboard")}
        </MenuItem>
      )}
      {roles.USERS && (
        <MenuItem key="/users" icon={<UserIcon />}>
          {t("main_menu.users")}
        </MenuItem>
      )}
      {(roles.VIRTUAL_SECURITY || roles.VIRTUAL_SECURITY_MACHINE_LICENSES) && (
        <SubMenu
          key="/licenses"
          icon={<KeyIcon />}
          title={t("main_menu.licenses")}
        >
          {roles.VIRTUAL_SECURITY && (
            <MenuItem key="/licenses/softwarelicenses" >
              {t("main_menu.software_licenses")}
            </MenuItem>
          )}
          {roles.VIRTUAL_SECURITY_MACHINE_LICENSES && (
            <MenuItem key="/licenses/machinelicenses" >
              {t("main_menu.machine_licenses")}
            </MenuItem>
          )}
        </SubMenu>
      )}

      {roles.SYSTEM && (
        <SubMenu
          key="/system"
          icon={<DiskIcon />}
          title={t("main_menu.system")}
        >
          {
            // commented
            roles.SYSTEM_PRODUCTS_VIEW && (
              <MenuItem key="/system/products">
                {t("main_menu.products")}
              </MenuItem>
            )
          }

          {/* {
     roles.DEV_TOOLS && <MenuItem key="/system/devtool" icon={<FormatIcon />}>
         Development Tools
      </MenuItem>
    } */}

          {/* {
     roles.HOOPS && <MenuItem key="/system/hoops" icon={<FormatIcon />}>
          Hoops Management
      </MenuItem>
    } */}

          {/* {
     roles.SYSTEM_CONFIG && <MenuItem key="/system/config" icon={<FormatIcon />}>
          System Config
      </MenuItem>
    } */}


          {roles.SYSTEM_HOOPS_VIEW && (
            <MenuItem key="/system/managehoops">
              {t("main_menu.hoops")}
            </MenuItem>
          )}
          {roles.SYSTEM_THREADS_VIEW && (
            <MenuItem key="/system/managethreads">
              {t("main_menu.threads")}
            </MenuItem>
          )}
          {roles.COUPONS && (
            <MenuItem key="/system/coupons">
              {t("main_menu.coupons")}
            </MenuItem>
          )}
          {roles.SYSTEM_SUPPLIERS_VIEW && (
            <MenuItem key="/system/managesupplier">
              {t("main_menu.suppliers")}
            </MenuItem>
          )}
          {roles.SYSTEM_SUPPLIERPRODUCTS_VIEW && (
            <MenuItem key="/system/managesupplierproducts">
              {t("main_menu.supplier_products")}
            </MenuItem>
          )}
          {roles.SYSTEM_STRINGS_VIEW && (
            <MenuItem key="/system/locale">
              {t("main_menu.local_strings")}
            </MenuItem>
          )}
          {/* {
     roles.SUPPORT && <MenuItem key="/system/support" icon={<FormatIcon />}>
          Support
      </MenuItem>
    } */}
          {/* {
     roles.THREADCHARTS && <MenuItem key="/system/thread" icon={<FormatIcon />}>
         Thread Charts
      </MenuItem>
    } */}
        </SubMenu>
      )}

      {roles.LICENSE_MANAGER && (
        <MenuItem key="/licensemanager" icon={<KeyIcon />}>
          {t("main_menu.licensemanager")}
        </MenuItem>
      )}
      {roles.URL_FORWARDS && (
        <MenuItem key="/urlforward" icon={<ForwardIcon />}>
          {t("main_menu.tiny_url")}
        </MenuItem>
      )}
      {roles.SYSTEM_INSTALLERS_VIEW && (
        <MenuItem key="/downloads" icon={<DownloadIcon />}>
          {t("main_menu.downloads")}
        </MenuItem>
      )}

      {roles.REPORTS && (
        <SubMenu key="/reports" icon={<DiskIcon />} title="Reports">
          {roles.REPORTS_PRODUCTION_BILLING && (
            <MenuItem key="/reports/downloadsbilling" >
              {t("main_menu.download_billing")}
            </MenuItem>
          )}
          {roles.REPORTS_PAYMENTS && (
            <MenuItem key="/reports/payments" >
              {"Payments"}
            </MenuItem>
          )}
        </SubMenu>
      )}

      {roles.ANALYTICS && (
        <SubMenu
          key="/analytics"
          icon={<DiskIcon />}
          title={t("main_menu.analytics")}
        >
          {roles.EMAIL_HISTORY && (
            <MenuItem key="/analytics/emails">{t("main_menu.emails")}</MenuItem>
          )}
        </SubMenu>
      )}

      {roles.TOOLS && (
        <SubMenu key="/tools" icon={<ToolIcon />} title={t("main_menu.tools")}>
          {roles.LOGS && (
            <MenuItem key="/tools/logs">{t("main_menu.logs")}</MenuItem>
          )}



          {roles.SUMMIT && (
            <MenuItem

              key="/tools/summit"

            >
              {/* <span
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenSUMMIT(true);
                }}
                style={{ display: "block" }}

              > */}
              {t("main_menu.summit")}
              {/* </span> */}

            </MenuItem>
          )}
          {roles.DIGITIZING_ORDERS && (<MenuItem

            key="/tools/digitizingorder"

          >

            {t("main_menu.digitizing_orders_logs")}
            {/* </span> */}

          </MenuItem>)}
        </SubMenu>
      )}
    </Menu>
      <StyledModal
        // closeIcon={
        //   <CloseIcon style={{ top: 0, right: 20, position: 'relative', zIndex: 1051 }} />
        // }
        open={openSUMMIT}
        onCancel={() => setOpenSUMMIT(false)}
        footer={null}
        width="70%"
        // style={{ top: "5%" }}
        styles={{
          body: { height: "95vh", padding: 0 },
        }}
        maskClosable={false}
        destroyOnClose
        centered
      >
        <Summit />
      </StyledModal>
    </>);
};
